type FloodingLocales = {
  places: { [key: string]: { label: string } }
  labels: { [key: string]: string }
}
export const Flooding_DE: FloodingLocales = {
  places: {
    NewYork: { label: 'New York' },
    Amsterdam: { label: 'Amsterdam' },
    Venedig: { label: 'Venedig' },
    Bangladesh: { label: 'Bangladesch' },
    London: { label: 'London' },
    Lissabon: { label: 'Lissabon' },
  },
  labels: {
    title: 'Diese Gebiete werden bei einem Meeresspiegelanstieg überflutet',
    floodLevelRise: 'Meerespiegelanstieg',
    source: 'Quelle: United States Geological Survey / Die überfluteten Flächen werden aufgrund ihrer Höhe über dem Meeresspiegel eingefärbt. Natürliche oder künstliche Merkmale, die den Wasserfluss beeinflussen (Deiche etc.), werden nicht berücksichtigt.',
    floodHint: 'Anstieg auswählen',
    placeHint: 'Ort auswählen',
  },
}

export const Flooding_FR: FloodingLocales = {
  places: {
    NewYork: { label: 'New York' },
    Amsterdam: { label: 'Amsterdam' },
    Venedig: { label: 'Venise' },
    Bangladesh: { label: 'Bangladesh' },
    London: { label: 'Londres' },
    Lissabon: { label: 'Lisbonne' },
  },
  labels: {
    title: "Ces zones seront submergées en cas d'élévation du niveau de la mer",
    floodLevelRise: 'Montée du niveau de la mer',
    source: "Source: United States Geological Survey / Les zones inondées sont colorées en fonction de leur hauteur par rapport au niveau de la mer. Les caractéristiques naturelles ou artificielles qui influencent l'écoulement de l'eau (par exemple les digues) ne sont pas prises en compte.",
    floodHint: "Sélectionner l'élévation"
    ,
    placeHint: 'FR_Ort auswählen',
  },
}
